import * as React from 'react';
import { domainDetails } from "../domainDetails";
import { Outlet, useNavigate } from 'react-router-dom';
import SearchBar from './SearchBar';
import { Box, Button, Container, Grid } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import TopBar from './TopBar';
import useIsMobile from './isMobile';
import UserVerification from './UserVerification';
import { useAppContext } from '../AppContext';

export default function Layout() {
    let host = window.location.host;
    const subdomain = host.split('.')[0];
    const currentDomain = domainDetails[subdomain];

    const theme = useTheme();
    const { values, setValues } = useAppContext();
    const navigate = useNavigate();

    React.useEffect(() => {
        let title = 'Proship Order Tracking';
        if (domainDetails[host]) {
            title = `${domainDetails[host].name} - Order Tracking - Powered By Proship`;
        }
        document.title = title;
    }, [host]);

    const largeBannerImage = currentDomain?.banner?.large || null;
    const smallBannerImage = currentDomain?.banner?.small || null;
    const webUrl = currentDomain?.webUrl || null;

    const handleTrackAnother = () => {
        setValues(null);
        navigate('/');
    };

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            {(largeBannerImage && smallBannerImage) ? (
                <Banner webUrl={webUrl} largeBannerImage={largeBannerImage} smallBannerImage={smallBannerImage} />
            ) : (
                <TopBar />
            )}
            <Box sx={{ flexGrow: 1 }}>
                <Container sx={{ my: { xs: 2, sm: 3 }, mb: { xs: 4, sm: 8 } }}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <UserVerification />
                        </Grid>
                        {(!values?.orderDetails) && (
                            <Grid item xs={12}>
                                <SearchBar />
                            </Grid>
                        )}
                        {values?.orderDetails && (
                            <Grid item xs={12}>
                                <Button
                                    variant="outlined"
                                    size="small"
                                    onClick={handleTrackAnother}
                                    sx={{
                                        borderColor: 'rgba(0,0,0,0.12)',
                                        color: 'text.secondary',
                                        '&:hover': {
                                            borderColor: 'primary.main',
                                            color: 'primary.main',
                                            bgcolor: alpha(theme.palette.primary.main, 0.04),
                                        },
                                    }}
                                >
                                    &larr; Track another order
                                </Button>
                            </Grid>
                        )}
                        <Grid item xs={12}>
                            <Outlet />
                        </Grid>
                    </Grid>
                </Container>
            </Box>
            {largeBannerImage && smallBannerImage && (
                <Box sx={{ mt: 'auto' }}>
                    <TopBar />
                </Box>
            )}
        </Box>
    );
}

function Banner({ largeBannerImage, smallBannerImage, webUrl }) {

    const isMobile = useIsMobile();

    return (
        <Box
            sx={{
                width: '100%',
                cursor: 'pointer',
                'img': {
                    width: '100%'
                }
            }}
            onClick={() => {
                if (webUrl) window.open(webUrl);
            }}
        >
            <img src={isMobile ? smallBannerImage : largeBannerImage} alt="Brand Banner" />
        </Box>
    );
}
